"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var AuditLog = /*#__PURE__*/function () {
  function AuditLog() {
    _classCallCheck(this, AuditLog);

    this._log = [];
  }

  _createClass(AuditLog, [{
    key: "log",
    value: function log(event, type, group, meta) {
      var auditLogEntry = {
        time: Date.now(),
        type: type,
        event: event,
        meta: meta,
        group: group
      };

      this._log.push(auditLogEntry);
    }
  }, {
    key: "getLog",
    value: function getLog(filter) {
      return lodash_1.default.filter(this._log, filter);
    }
  }, {
    key: "printLog",
    value: function printLog(filter) {
      this.getLog(filter).forEach(this.printLogEntry);
    }
  }, {
    key: "printLogEntry",
    value: function printLogEntry(entry) {
      var _a;

      console.log("%c event: ".concat(entry.event), "color: green");
      console.group();
      console.log("type: ".concat(entry.type));
      console.log("time: ".concat(entry.time));
      console.log("meta: ".concat(JSON.stringify((_a = entry.meta) !== null && _a !== void 0 ? _a : {})));
      console.groupEnd();
    }
  }]);

  return AuditLog;
}();

exports.default = AuditLog;